import React from "react";
import {
    Box,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Popover,
    Typography,
} from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";
import { withTranslation } from 'react-i18next';

export const HelpPopover = withTranslation()(function HelpPopover({ t }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClickHelp = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseHelp = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
        <>
            <IconButton onClick={handleClickHelp}>
                <HelpIcon style={{ color: "#7786fc" }} />
            </IconButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleCloseHelp}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                PaperProps={{
                    style: {
                        width: 450,
                        backgroundColor: "rgba(70, 70, 70, .9)",
                    },
                }}
            >
                <Box padding={2}>
                    <Typography style={{ color: "white" }}>
                        {t('helpPopover.intro')}
                    </Typography>
                </Box>
                <Box>
                    <List disablePadding>
                        <ListItem
                            dense
                            style={{
                                paddingTop: 0,
                                paddingBottom: 0,
                            }}
                        >
                            <ListItemText>
                                <Typography style={{ color: "white" }}>
                                    {t('helpPopover.attributes')}
                                </Typography>
                            </ListItemText>
                        </ListItem>
                        <ListItem
                            dense
                            style={{
                                paddingTop: 0,
                                paddingBottom: 0,
                            }}
                        >
                            <ListItemText>
                                <Typography style={{ color: "white" }}>
                                    <b>{t('helpPopover.attr.nombre.label')}</b> {t('helpPopover.attr.nombre.desc')}
                                </Typography>
                            </ListItemText>
                        </ListItem>
                        <ListItem
                            dense
                            style={{
                                paddingTop: 0,
                                paddingBottom: 0,
                            }}
                        >
                            <ListItemText>
                                <Typography style={{ color: "white" }}>
                                    <b>{t('helpPopover.attr.tipo.label')}</b> {t('helpPopover.attr.tipo.desc')}
                                </Typography>
                            </ListItemText>
                        </ListItem>
                        <ListItem
                            dense
                            style={{
                                paddingTop: 0,
                                paddingBottom: 0,
                            }}
                        >
                            <ListItemText>
                                <Typography style={{ color: "white" }}>
                                    <b>{t('helpPopover.attr.javascript.label')}</b> {t('helpPopover.javascript.part1')}<em>script</em>{t('helpPopover.javascript.part2')}
                                </Typography>
                            </ListItemText>
                        </ListItem>
                        <ListItem
                            dense
                            style={{
                                paddingTop: 0,
                                paddingBottom: 0,
                            }}
                        >
                            <ListItemText>
                                <Typography style={{ color: "white" }}>
                                    <b>{t('helpPopover.attr.regexp.label')}</b> {t('helpPopover.attr.regexp.desc')}
                                </Typography>
                            </ListItemText>
                        </ListItem>
                        <ListItem
                            dense
                            style={{
                                paddingTop: 0,
                                paddingBottom: 0,
                            }}
                        >
                            <ListItemText>
                                <Typography style={{ color: "white" }}>
                                    <b>{t('helpPopover.attr.objetivo.label')}</b> {t('helpPopover.attr.objetivo.desc')}
                                </Typography>
                            </ListItemText>
                        </ListItem>
                        <ListItem
                            dense
                            style={{
                                paddingTop: 0,
                                paddingBottom: 10,
                            }}
                        >
                            <ListItemText>
                                <Typography style={{ color: "white" }}>
                                    <b>{t('helpPopover.attr.posicion.label')}</b> {t('helpPopover.position.part1')}
                                    <em>dom</em>
                                    {" "}{t('helpPopover.position.connector')}{" "}
                                    <em>regexp</em>.
                                </Typography>
                            </ListItemText>
                        </ListItem>
                    </List>
                </Box>
            </Popover>
        </>
    );
});
